const ROUTES = {
  Index: '/',
  SignIn: '/auth/sign-in',
  SignUp: '/auth/sign-up',
  ForgotPassword: '/auth/forgot-password',
  ResetPassword: '/auth/reset-password',
  ChangePassword: '/auth/change-password',
  Chats: '/chats',
  Projects: '/projects',
  PrivacyPolicy: '/policies/privacy-policy',
};

const PROTECTED_ROUTES: string[] = [ROUTES.Index, ROUTES.Chats, ROUTES.Projects, ROUTES.ChangePassword];
const AUTH_ROUTES: string[] = [ROUTES.SignIn, ROUTES.SignUp, ROUTES.ForgotPassword, ROUTES.ResetPassword];
const PUBLIC_ROUTES: string[] = [ROUTES.PrivacyPolicy];

export { ROUTES, PROTECTED_ROUTES, AUTH_ROUTES, PUBLIC_ROUTES };
